import { styled } from '@mui/material';

interface ChipStyledProps {
  attrs?: {
    blurred?: boolean;
  };
}

const ChipStyled = styled('div')<ChipStyledProps>(({ theme, attrs }) => ({
  width: 'fit-content',
  blockSize: 'fit-content',
  padding: theme.spacing(0.4, 1.4),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(0.8),
  borderRadius: theme.spacing(1),
  fontSize: 14,
  opacity: attrs?.blurred ? 0.5 : 1,
}));

export const ChipPendingStyled = styled(ChipStyled)(({ theme }) => ({
  background: theme.palette.warning.main,
  color: theme.palette.white.main,
}));

export const ChipDangerStyled = styled(ChipStyled)(({ theme }) => ({
  background: theme.palette.error.main,
  color: theme.palette.white.main,
}));
export const ChipAcceptedStyled = styled(ChipStyled)(({ theme }) => ({
  background: theme.palette.secondary.main,
  color: theme.palette.white.main,
}));
